
const mixin = {
  methods: {
    getObjectCopy (obj) {
      return JSON.parse(JSON.stringify(obj))
    }
  }
}

export default mixin
